import * as FontFaceObserver from 'fontfaceobserver';

const lato = new FontFaceObserver('Lato');
const roboto = new FontFaceObserver('Roboto');
const raleway = new FontFaceObserver('Raleway');
const playfair = new FontFaceObserver('Playfair Display');

const host = window.location.href;

const stack = [roboto];

if (host.indexOf('travelvisa') > -1 ||  host.indexOf('rushmytravelvisa') > -1) {
  stack.push(lato);
} else if (host.indexOf('onlineexpeditors') > -1 || host.indexOf('passportcenter') > -1) {
  stack.push(playfair);
} else if (host.indexOf('passportrenewal') > -1) {
  stack.push(raleway);
}

let fontsLoaded = false;

Promise.all(stack).then(() => {
  document.documentElement.className += ' gw-fonts-loaded';
  fontsLoaded = true;
}).catch(() => {});

try {
  window.sessionStorage.fontsLoaded = fontsLoaded;
} catch (e) {}



// WEBPACK FOOTER //
// ./resources/assets/js/fonts.ts